module.exports = __webpack_public_path__ + "static/media/go-back.3410b486.svg";